let getLocale = () => "es-ES";
let getCurrency = () => "EUR";

export function configureFormatters({ localeGetter, currencyGetter }) {
  getLocale = localeGetter;
  getCurrency = currencyGetter;
}

export function formatCurrency(amount, decimals = 0, currency = false) {
    if (!['number', 'string'].includes(typeof amount) || (typeof amount === 'string' && !amount.trim())) return '-'
    let numeric = Number(amount)
    if (!Number.isFinite(numeric) || !Number.isInteger(decimals) || decimals < 0 || decimals > 20) return '-'
    if (Math.abs(numeric) < 0.5 * Math.pow(10, -decimals)) numeric = 0
    const locale = getLocale() || 'es-ES';
    const curr = currency || getCurrency() || 'EUR';
    try {
        // Intl runtimes differ on Italian four-digit grouping; keep the shared standard.
        return new Intl.NumberFormat(locale, { style: "currency", currency: curr, currencyDisplay: "symbol", useGrouping: locale === 'it-IT' ? true : undefined, minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(numeric);
    } catch (_) {
        return '-'
    }
}
